import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

import { ComodoModelo } from '../../models/comodo-modelo';
import { ItemVistoriaComodoModelo } from '../../models/item-vistoria-comodo-modelo';
import { ItemVistoriaModelo } from '../../models/item-vistoria-modelo';

@Component({
  selector: 'app-comodos-modelo-vistoria',
  standalone: false,
  templateUrl: './comodos-modelo-vistoria.component.html',
  styleUrl: './comodos-modelo-vistoria.component.scss'
})
export class ComodosModeloVistoriaComponent {

  @Input() comodos: ComodoModelo[] = [];
  @Output() comodosChange = new EventEmitter<ComodoModelo[]>();

  // Pool de itens da aba "Itens de Vistoria", pra escolher o que vincular a cada cômodo.
  @Input() itensDoModelo: ItemVistoriaModelo[] = [];

  itemParaAdicionar: ItemVistoriaModelo | null = null;

  constructor(private dialog: MatDialog) { }

  public adicionar(): void {
    const novo: ComodoModelo = { id: 0, nome: '', ordem: 0, itens: [] };
    this.comodos.push(novo);
    this.emitir();
  }

  public confirmarRemocao(comodo: ComodoModelo): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.titulo = 'Remover cômodo';
    dialogRef.componentInstance.mensagem = `O cômodo "${comodo.nome || '-'}" será removido.`;
    dialogRef.componentInstance.textoBtnConfirmacao = 'Remover';
    dialogRef.componentInstance.btnBackgroundColor = '#F44336';
    dialogRef.componentInstance.acaoConfirmacao = () => this.remover(comodo);
  }

  private remover(comodo: ComodoModelo): void {
    this.comodos = this.comodos.filter(c => c !== comodo);
    this.emitir();
  }

  public duplicarComodo(comodo: ComodoModelo): void {
    const copia: ComodoModelo = {
      id: 0,
      nome: `Cópia de ${comodo.nome}`,
      ordem: 0,
      itens: comodo.itens.map(v => ({ ...v })),
    };
    this.comodos.splice(this.comodos.indexOf(comodo) + 1, 0, copia);
    this.emitir();
  }

  public itensDisponiveis(comodo: ComodoModelo): ItemVistoriaModelo[] {
    const jaVinculados = new Set(comodo.itens.map(cc => cc.item));
    return this.itensDoModelo.filter(c => !jaVinculados.has(c));
  }

  public adicionarItem(comodo: ComodoModelo, item: ItemVistoriaModelo | null): void {
    if (!item) return;
    comodo.itens.push({ id: 0, item, ordem: 0 });
    this.itemParaAdicionar = null;
  }

  public removerItem(comodo: ComodoModelo, vinculo: ItemVistoriaComodoModelo): void {
    comodo.itens = comodo.itens.filter(cc => cc !== vinculo);
  }

  public moverItem(comodo: ComodoModelo, vinculo: ItemVistoriaComodoModelo, delta: number): void {
    const lista = comodo.itens;
    const index = lista.indexOf(vinculo);
    const novoIndex = index + delta;
    if (novoIndex < 0 || novoIndex >= lista.length) return;
    [lista[index], lista[novoIndex]] = [lista[novoIndex], lista[index]];
  }

  // Chamado pelo form pai quando um item é removido na aba "Itens de Vistoria": limpa qualquer
  // vínculo (em qualquer cômodo) que apontava pra ele.
  public removerVinculosDoItem(item: ItemVistoriaModelo): void {
    this.comodos.forEach(comodo => {
      comodo.itens = comodo.itens.filter(cc => cc.item !== item);
    });
  }

  private emitir(): void {
    this.comodosChange.emit(this.comodos);
  }
}
